/** /sso/landing exchanges SaaSBOXX's short-lived token for a local session, then drops the user into the app. */
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChefHat, Loader2, AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const SsoLanding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (!token) {
      setError('Missing SSO token in the URL.');
      return;
    }

    (async () => {
      try {
        const resp = await fetch(`${API_URL}/users/login/auth/sso/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await resp.json();
        if (!resp.ok || !data.success) {
          setError(data.error || 'SSO accept failed. Please try logging in directly.');
          return;
        }
        login(data.data.user, { token: data.data.token });
        // Belt-and-braces: also start a server-side session
        try {
          await fetch(`${API_URL}/users/session/start/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${data.data.token}`,
            },
            body: JSON.stringify({ user_id: data.data.user.id }),
          });
        } catch (_) {}
        navigate('/', { replace: true });
      } catch (err) {
        setError('Network error during SSO. Please try again.');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-700 via-red-600 to-orange-600 p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center space-y-6">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-red-600 to-orange-500 flex items-center justify-center">
          <ChefHat className="w-9 h-9 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">RestoBOXX</h1>

        {error ? (
          <>
            <div className="flex items-start gap-2 p-3 rounded-lg border border-red-200 bg-red-50 text-red-700 text-sm text-left">
              <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <span>{error}</span>
            </div>
            <button
              onClick={() => navigate('/login')}
              className="w-full py-2.5 px-4 rounded-lg bg-gradient-to-r from-red-600 to-orange-500 text-white font-medium hover:from-red-700 hover:to-orange-600 transition"
            >
              Go to sign in
            </button>
          </>
        ) : (
          <div className="flex items-center justify-center gap-3 text-gray-600">
            <Loader2 className="w-5 h-5 animate-spin text-red-600" />
            <span>Signing you in via SaaSBOXX…</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SsoLanding;
